import types from './types'

export default {
  addSuccessNotify: notification => ({ type: types.ADD_SUCCESS, payload: notification }),
  addErrorNotify: notification => ({ type: types.ADD_ERROR, payload: notification }),
  addWarningNotify: notification => ({ type: types.ADD_WARNING, payload: notification }),
  makeEmptyNotify: notification => ({ type: types.MAKE_EMPTY, payload: notification }),
}
